import React, { Component } from "react";
import Navbar from "website/components/Navbar/Navbar";
import Hero from "website/components/Hero/Hero";
import { Info } from "website/components/Info/Info";
import Products from "website/components/Products/Products";
import Services from "website/components/Services/Services";
// import News from "website/containers/News/News";
import Features from "website/components/Features/Features";
import Reviews from "website/containers/Reviews/Reviews";
import Footer from "website/components/Footer/Footer";
// import Pricing from "../Pricing/Pricing";
import { connect } from "react-redux";
import {
  requestHeroContent,
  requestInfoContent,
  requestProductsContent,
  requestFeaturesContent,
  requestQuestionsContent,
  requestCounterContent,
  requestLogosContent
} from "../../../store/actions/index";
import { Payment } from "website/components/Payment/Payment";
import { FreeTrial } from "website/components/FreeTrial/FreeTrial";
import { Clients } from "website/components/Clients/Clients";
import  Counter  from "website/components/Counter/Counter";
import DemoView from "website/components/DemoView/DemoView";
import './Home.scss';
class Home extends Component {
  componentDidMount = () => {
    this.props.requestHeroContent();
    this.props.requestInfoContent();
    this.props.requestFeaturesContent();
    this.props.requestProductsContent();
    this.props.requestQuestionsContent();
    this.props.requestCounterContent(); 
    this.props.requestLogosContent();
  };
  render() {
    const { homeContent } = this.props;
    return (
      <div className="home__section">
        <Navbar />
        <Hero content={homeContent.hero} />
        <Info content={homeContent.info} />
        <Counter counter={homeContent.counter}/>
        {/* <Products content={homeContent.products} /> */}
        {/* <Services content={homeContent.products} /> */}
        <Services  />
        <DemoView/>
        <Clients  logos={homeContent.logos}/>
        <Features content={homeContent.features} />
        <FreeTrial content={homeContent.pricingPage}/>
        {/* <Pricing from="home" /> */}
        {/* <Payment /> */}
        {/* <News /> */}
        {/* <Reviews /> */}
        {/* <Questions content={homeContent.questions} /> */}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    homeContent: state.website.homeContent,
  };
};

export default connect(mapStateToProps, {
  requestHeroContent,
  requestFeaturesContent,
  requestInfoContent,
  requestQuestionsContent,
  requestProductsContent,
  requestCounterContent,
  requestLogosContent
})(Home);
